var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "swiper-container swiper-slider" },
    [
      _c(
        "div",
        { staticClass: "swiper-wrapper swiper-slider--wrapper" },
        _vm._l(_vm.items, function(item, index) {
          return _c(
            "div",
            { key: index, staticClass: "swiper-slide swiper-slider--slide" },
            [_vm._t("default", null, null, item)],
            2
          )
        })
      ),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-pagination swiper-slider--pagination" }),
      _vm._v(" "),
      _c(
        "base-btn",
        {
          staticClass: "swiper-slider--nav swiper-slider--nav__prev",
          attrs: { size: "medium", facets: ["bubble", _vm.buttonColorFacet] }
        },
        [
          _c("base-icon", {
            staticClass: "swiper-slider--icon",
            attrs: { symbol: "chevron-left", size: "medium" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "base-btn",
        {
          staticClass: "swiper-slider--nav swiper-slider--nav__next",
          attrs: { size: "medium", facets: ["bubble", _vm.buttonColorFacet] }
        },
        [
          _c("base-icon", {
            staticClass: "swiper-slider--icon",
            attrs: { symbol: "chevron-right", size: "medium" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18872274", { render: render, staticRenderFns: staticRenderFns })
  }
}